import axios from 'axios'
const date = {
		//	获取数据更新时间
		getDataUpdateTime:function(){
            var updateTime;
            var tradeSchedule;
            var myDate	= new Date();
            return new Promise((resolve, reject) => {
                axios.get(process.env.Trade_Schedule_Url)
                    .then((res) => {
                        var isTradingDay;
                        tradeSchedule=res.data.data.list;
                        var isTradingDay=function(myDate){
                            // 格式化日期 判断是否为交易日
                            var y = myDate.getFullYear();
                            var m = myDate.getMonth()+1;
                            m = m < 10 ? '0' + m : '' + m;
                            var d = myDate.getDate() <10 ? '0'+myDate.getDate():''+myDate.getDate();
                            var ymd = y+m+d;
                            if (tradeSchedule.indexOf(ymd) > -1) {
                                return true;
                            }else{
                                return  false;
                            }
                        };
                        if(isTradingDay(myDate) && !(this.timeRange("00:00","09:25"))){
                            if(this.timeRange("9:25","11:30") || this.timeRange("13:00","15:00")){
                                updateTime=this.formt(myDate,"yyyy-MM-dd hh:mm");
                            }else if(this.timeRange("11:30","12:50")){
                                updateTime=this.formt(myDate,"yyyy-MM-dd")+" 11:30";
                            }else{
                                updateTime=this.formt(myDate,"yyyy-MM-dd")+" 15:00";
                            }
                        }else{
                            var flag =false;
                            do
                            {
                                myDate.setDate(myDate.getDate()-1);
                                flag=isTradingDay(myDate);
                                console.log(1);
                            }
                            while (!flag)
                            updateTime=this.formt(myDate,"yyyy-MM-dd")+" 15:00";
                        }
                        var data={"isTradingDay":isTradingDay(new Date()),"updateTime":updateTime}
                        resolve(data);
                    })
                    .catch(function (error) {
                        reject(error);
                        // console.log(error);
                    });
            });
		},
		//获取当前时间
		getCurrentTime: function() {
			var today = new Date();
			var year = today.getFullYear();
			var month = today.getMonth() + 1;
			var day = today.getDate();
			var hours = today.getHours();
			var minutes = today.getMinutes();
			var seconds = today.getSeconds();
			var timeString = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
			return timeString;
		},
		/*
		 * 比较时间大小
		 * time1>time2 return 1
		 * time1<time2 return -1
		 * time1==time2 return 0
		 */
		compareTime: function(time1, time2) {
			if(Date.parse(time1.replace(/-/g, "/")) > Date.parse(time2.replace(/-/g, "/"))) {
				return 1;
			} else if(Date.parse(time1.replace(/-/g, "/")) < Date.parse(time2.replace(/-/g, "/"))) {
				return -1;
			} else if(Date.parse(time1.replace(/-/g, "/")) == Date.parse(time2.replace(/-/g, "/"))) {
				return 0;
			}
		},
    //当前时间是否在某一时间段
    timeRange: function (beginTime, endTime) {
      var strb = beginTime.split (":");
      if (strb.length != 2) {
          return false;
      }

      var stre = endTime.split (":");
      if (stre.length != 2) {
          return false;
      }

      var b = new Date ();
      var e = new Date ();
      var n = new Date ();

      b.setHours (strb[0]);
      b.setMinutes (strb[1]);
      e.setHours (stre[0]);
      e.setMinutes (stre[1]);
      if (n.getTime () - b.getTime () >=0 && n.getTime () - e.getTime () <0) {
          return true;
      } else {
          return false;
      }
    },
		//是否闰年
		isLeapYear: function(year) {
			return((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
		},
		//获取某个月的天数，从0开始
		getDaysOfMonth: function(year, month) {
			return [31, (this.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
		},
		getDaysOfMonth2: function(year, month) {
			// 将天置为0，会获取其上个月的最后一天
			month = parseInt(month) + 1;
			var date = new Date(year, month, 0);
			return date.getDate();
		},
		/*距离现在几天的日期：负数表示今天之前的日期，0表示今天，整数表示未来的日期
		 * 如-1表示昨天的日期，0表示今天，2表示后天
		 */
		fromToday: function(days) {
			var today = new Date();
			today.setDate(today.getDate() + days);
			var date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
			return date;
		},
		/**
		 * 日期时间格式化
		 * @param {Object} dateTime 需要格式化的日期时间
		 * @param {String} pattern  格式化的模式，如yyyy-MM-dd hh(HH):mm:ss.S a k K E D F w W z Z
		 */
		formt: function(dateTime, pattern) {
			var date=dateTime;
			var fmt=pattern;
			var o = {
		     "M+" : date.getMonth()+1,                 //月份
		     "d+" : date.getDate(),                    //日
		     "h+" : date.getHours(),                   //小时
		     "m+" : date.getMinutes(),                 //分
		     "s+" : date.getSeconds(),                 //秒
		     "q+" : Math.floor((date.getMonth()+3)/3), //季度
		     "S"  : date.getMilliseconds()             //毫秒
		   };
		   if(/(y+)/.test(fmt))
		     fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
		   for(var k in o)
		     if(new RegExp("("+ k +")").test(fmt))
		   fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
		   return fmt;
		},
		/**
		 * 计算一个日期是当年的第几天
		 * @param {Object} date
		 */
		dayOfTheYear: function(date) {
			var obj = new Date(date);
			var year = obj.getFullYear();
			var month = obj.getMonth(); //从0开始
			var days = obj.getDate();
			var daysArr = [31, (this.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
			for(var i = 0; i < month; i++) {
				days += daysArr[i];
			}
			return days;
		},
		//获得时区名和值
		getZoneNameValue: function(dateObj) {
			var date = new Date(dateObj);
			date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
			var arr = date.toString().match(/([A-Z]+)([-+]\d+:?\d+)/);
			var obj = {
				'name': arr[1],
				'value': arr[2]
			};
			return obj;
		}
	};
export default date


// WEBPACK FOOTER //
// ./src/utils/date.js